<template>
  <div
    class="mobile-nav-header"
    :class="{
      'mobile-nav-header--enhanced': isDesktop,
    }"
    data-testid="mobile-nav-header"
  >
    <div v-if="isDesktop" class="padding-bottom-s padding-top-s">
      <BackButton
        class="grid-x align-middle"
        :icon-classes="{
          'chevron-small-left-black': isMcom,
          'chevron-large-left': !isMcom,
        }"
      >
        <span class="mobile-nav-back">Back</span>
      </BackButton>
    </div>
    <div class="mobile-nav-header__title grid-x align-middle">
      <div class="cell" :class="isMcom && url?.length ? 'small-9' : 'small-12'">
        <h6 v-if="isDesktop && isMcom">
          <span>{{ title }}</span>
          <ToysIcon v-if="isToysCategory({ id, text: title })" img-class="margin-left-xxs" big />
        </h6>
        <h6 v-else-if="isDesktop && !isMcom">
          {{ title }}
        </h6>
        <h5
          v-else
          class="transform-account padding-bottom-xs padding-top-s"
          :class="{
            'hnf-to-normal-case': !textTransform,
          }"
          tabindex="0"
        >
          <span>{{ title }}</span>
          <ToysIcon v-if="isMcom && isToysCategory({ id, text: title })" :alt="title" img-class="margin-left-xxs" big />
        </h5>
      </div>
      <div
        v-if="isMcom && url?.length && id !== 'LOYALLIST'"
        class="cell small-3"
        :class="{
          'margin-top-xxs': !isDesktop,
        }"
      >
        <Link
          :href="props.url"
          :tracking="props.tracking"
          :aria-label="`Shop All ${title}`"
          data-testid="shop-all-button"
          class="link-sm grid-x align-right"
        >
          Shop All
        </Link>
      </div>
    </div>
  </div>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed } from 'vue';

import isToysCategory from '~/utils/isToysCategory';
import Link from '../common/Link';
import ToysIcon from '../dumb/ToysIcon.mcom';
import { GET_IS_DESKTOP_VIEW } from '#shared/types/getters';
import BackButton from './BackButton.common.vue';

const props = defineProps({
  id: {
    type: String,
    default: null, // optional
  },
  title: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    default: '',
  },
  textTransform: {
    type: Boolean,
    default: true,
  },
  tracking: {
    type: Object,
    default: () => ({}),
  },
});

const envProps = useEnvProps();
const navViewType = useNavViewType();

const isMcom = envProps.isMcom;
const isDesktop = computed(() => navViewType?.[GET_IS_DESKTOP_VIEW]);
</script>

<style lang="scss" scoped>
.transform-account {
  text-transform: capitalize;
}

button {
  cursor: pointer;
}

.mobile-nav-back {
  margin-left: 4px;
}
</style>

<style lang="scss" scoped>
.mobile-nav-header {
  border-bottom: $hr-gray-divider;

  &--enhanced {
    padding-bottom: 8px;
    border: none;
  }

  .mobile-nav-header__title {
    h5,
    h6 {
      display: flex;
      align-items: center;
      font-weight: 500;
    }
  }
}
</style>
